package one.healthium.log_food.ui.scan_results.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import one.healthium.ui.compose.components.AppIcons
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.gray_3
import org.jetbrains.compose.resources.painterResource

/**
 * A clickable row intended for use inside a [one.healthium.profile.ui.food.components.FoodDetails]
 * card's bottomContent slot. Unlike [one.healthium.profile.ui.food.components.DetailsRow], this
 * variant has no outer card background — it sits directly inside the parent card's background.
 */
@Composable
internal fun DetailsRowInCard(
    modifier: Modifier = Modifier,
    title: String,
    value: String,
    onClick: () -> Unit,
) {
    Row(
        modifier = modifier
            .fillMaxWidth()
            .clickable(onClick = onClick)
            .padding(horizontal = 12.dp, vertical = 12.dp),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Text(
            modifier = Modifier.weight(1f),
            text = title,
            style = AppTheme.textStyles.secondary_16_400,
            color = AppTheme.colors.text100,
        )
        Text(
            text = value,
            style = AppTheme.textStyles.secondary_16_500,
            color = gray_3,
            textAlign = TextAlign.End,
        )
        Spacer(Modifier.width(8.dp))
        Image(
            modifier = Modifier.size(width = 8.dp, height = 13.dp),
            painter = painterResource(AppIcons.icArrowRight),
            contentDescription = null,
        )
    }
}
